import Box from "@material-ui/core/Box";
import Delete32 from "@carbon/icons-react/lib/delete/32";
import Add32 from "@carbon/icons-react/lib/add/32";
import React from "react";
import { IconButton, SecondaryButton } from "@prestosports/commons-ui";
import GameSet from "./GameSet";

const MatchTiebreakSets = ({
	match,
	onAddSet,
	onRemoveSet,
	onAwayScoreChange,
	onAwayTiebreakChange,
	onHomeScoreChange,
	onHomeTiebreakChange,
	maxSetTiebreak
}) => {
	const tiebreakSets = match.tiebreakSets || [];

	return (
		<Box display="flex" flexDirection="column" alignItems="center">
			{tiebreakSets.map((tiebreakSet, index) => (
				<Box display="flex" justifyContent="space-between" alignItems="center">
					<GameSet
						key={`${match.id}-${tiebreakSet.index}`}
						onAwayScoreChange={(gameSet) => onAwayScoreChange(index, gameSet)}
						onAwayTiebreakChange={(gameSet) => onAwayTiebreakChange(index, gameSet)}
						onHomeScoreChange={(gameSet) => onHomeScoreChange(index, gameSet)}
						onHomeTiebreakChange={(gameSet) => onHomeTiebreakChange(index, gameSet)}
						onClick={() => {}}
						disabled={false}
						index={match.sets.length + index}
						match={match}
						set={tiebreakSet}
						maxSetTiebreak={maxSetTiebreak}
					/>
					<IconButton
						id={`icon-button-delete-${index}`}
						onClick={() => onRemoveSet(index)}
					>
						<Delete32 />
					</IconButton>
				</Box>
			))}

			<SecondaryButton
				id="button-add-tiebreak-set"
				size="small"
				startIcon={<Add32 />}
				onClick={onAddSet}
				label="Add Set"
			/>
		</Box>
	);
};

export default MatchTiebreakSets;
